import { useEffect, useState } from "react";
import OverviewModal from "./DiagnosticOverview";

// Roster-level host for the diagnostic funnel. The page mounts exactly ONE of
// these instead of one island per row: the "View overview" buttons are plain
// server-rendered markup carrying data-overview-id, and this host listens for
// clicks (event delegation) to open a single shared modal. That keeps the page
// at one React root + one OutreachComposer subtree regardless of roster size.
export default function DiagnosticFunnel({ rows = [], csrf_token, intents = [], send_endpoint }) {
  const [activeRow, setActiveRow] = useState(null);

  useEffect(() => {
    const byId = new Map(rows.map((r) => [String(r.candidate_profile_id), r]));

    function onClick(e) {
      const trigger = e.target.closest("[data-overview-id]");
      if (!trigger) return;
      const row = byId.get(String(trigger.dataset.overviewId));
      if (row) {
        e.preventDefault();
        setActiveRow(row);
      }
    }

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [rows]);

  if (!activeRow) return null;

  return (
    <OverviewModal
      row={activeRow}
      csrf_token={csrf_token}
      intents={intents}
      send_endpoint={send_endpoint}
      onClose={() => setActiveRow(null)}
    />
  );
}
